import { useQuery } from "@tanstack/react-query";
import AppService from "../../service/AppService";

export const API_CONFIG_QUERY_KEY = ["apiConfig"];

const options = {
  queryKey: API_CONFIG_QUERY_KEY,
  queryFn: AppService.getApiConfig,
  staleTime: 60 * 60 * 24 * 1000, // 1 day
  refetchInterval: 60 * 60 * 24 * 1000,
  refetchOnWindowFocus: false,
  retry: 2,
};

export function useApiConfig() {
  return useQuery(options);
}
